var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsulting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_24);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_24",
    x1: -119.77,
    y1: 32,
    x2: -119.27,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed75c"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z1_\u8BCA\u7597\u884C\u4E3A\u5F02\u5E38") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.44,39.17h.05l.25,0A6.4,6.4,0,0,1,45,51.94a6.2,6.2,0,0,1-3.71-1.22h0A6.62,6.62,0,0,1,40,49.43l-.1-.12A6.73,6.73,0,0,1,39,47.43l0-.2a4.54,4.54,0,0,1-.12-.53l0-.17a6.46,6.46,0,0,1-.07-1A6.35,6.35,0,0,1,45,39.16h.42ZM32,12.06a3.53,3.53,0,0,1,1.89.56l.34.25,17,15.52a1.89,1.89,0,0,1,.56,2.07,1.8,1.8,0,0,1-1.43,1.25l-.29,0H48v6.52a8,8,0,0,0-9.14,12.47H19.6A3.65,3.65,0,0,1,16,47.38L16,47V31.73H13.89a1.81,1.81,0,0,1-1.73-1.27,1.93,1.93,0,0,1,.37-1.88l.2-.2,17-15.47,0,0A3.48,3.48,0,0,1,32,12.06ZM46.1,41.54a.9.9,0,0,0-.27.07l-.08,0-4,4.27,0,0a.28.28,0,0,0,0,.33.4.4,0,0,0,.36.17h1.9l-1,2.67s0,0,0,.05a.32.32,0,0,0,.09.28.36.36,0,0,0,.29.11.54.54,0,0,0,.22,0l.1-.06L48.31,45l0,0a.36.36,0,0,0,.06-.34.37.37,0,0,0-.31-.18h0l-2.11,0L46.5,42a.46.46,0,0,0-.1-.37.42.42,0,0,0-.3-.12ZM33.23,25.77H30.77a.94.94,0,0,0-.94.94V30h-3.1a1,1,0,0,0-.95.94V33.5a1,1,0,0,0,.95.94h3.09v3.24a.94.94,0,0,0,.95.94h2.45a.94.94,0,0,0,1-.94h0V34.44h3.1a.94.94,0,0,0,.94-.94h0V30.89a.94.94,0,0,0-.94-.94h-3.1V26.71a.94.94,0,0,0-.94-.94Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/Consulting.b17beb83.svg";
export { ForwardRef as ReactComponent };